export const AUTH_LOGIN = 'AUTH_LOGIN';

export function authLogin(payload) {
  return {
    type: AUTH_LOGIN,
    payload,
  };
}
